import "./TabComponent.css";
import { React, useState } from "react";
import ReactHtmlParser from "html-react-parser";

const TabComponent = (data) => {
  const tabData = data;
  const [activeTab, setActiveTab] = useState("tab0");

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="tab-items">
      <div className="tab-navigation">
        {Object.values(tabData).map((item, index) =>
          item.map((element, i) => (
            <button
              key={i}
              className={`tab-button ${
                activeTab === `tab${i}` ? "active" : ""
              }`}
              onClick={() => handleTabChange(`tab${i}`)}
            >
              {element.attributes.tab_name}
            </button>
          ))
        )}
      </div>
      <div className="tab-content">
        {Object.values(tabData).map((item, index) =>
          item.map(
            (element, i) =>
              activeTab === `tab${i}` && (
                <div className="card" key={i}>
                  {element.attributes.promotion_tab_details &&
                    element.attributes.promotion_tab_details.data.length !==
                      0 && (
                      <div
                        className="promotion--cards"
                        style={{
                          "--clr-scroll": element.attributes.card_color,
                          display: "flex",
                        }}
                        key={i}
                      >
                        {element.attributes.promotion_tab_details.data.map(
                          (item, index) => (
                            <div
                              className="promotion--card"
                              key={index}
                              style={{
                                background: element.attributes.card_color
                                  ? element.attributes.card_color
                                  : "initial",
                              }}
                            >
                              <div
                                className="promotion--card-details"
                                style={{ color:element.attributes.font_color ? element.attributes.font_color : "#fff" }}
                              >
                                <h3 style={{ marginBottom: "20px" , color:element.attributes.title_color ? element.attributes.title_color : "#000"}}>
                                  {item.attributes.title}
                                </h3>
                                <div className="card-benifits" style={{ fontSize: "18px" }}>
                                  {item.attributes.details.benifits &&
                                    Object.entries(
                                      item.attributes.details.benifits
                                    ).map(([key, value]) => (
                                      <p key={key}>{value}</p>
                                    ))}
                                </div>
                                <div className="card-properties">
                                  {item.attributes.details.properties &&
                                    Object.entries(
                                      item.attributes.details.properties
                                    ).map(([key, value]) => (
                                      <p key={key}>{value}</p>
                                    ))}
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    )}
                  {ReactHtmlParser(element.attributes.tab_detail)}
                </div>
              )
          )
        )}
      </div>
    </div>
  );
};

export default TabComponent;
